module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/overlay-left-active.bd833743.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/overlay-left-active.png
// module id = 2752
// module chunks = 11